export const OUTCOME_META = {
  solved: { label: "Solved by Nick", cls: "text-[#73bf44] border-[#73bf44]/30 bg-[#73bf44]/10", color: "#73bf44" },
  resolved_by_team: { label: "Resolved by team", cls: "text-emerald-300 border-emerald-500/30 bg-emerald-500/10", color: "#34d399" },
  escalated: { label: "Escalated", cls: "text-sky-300 border-sky-500/30 bg-sky-500/10", color: "#38bdf8" },
  outstanding: { label: "Outstanding", cls: "text-amber-400 border-amber-500/30 bg-amber-500/10", color: "#f59e0b" },
  no_question: { label: "No question", cls: "text-neutral-400 border-neutral-700 bg-neutral-800/40", color: "#525252" },
  pending: { label: "Not reviewed", cls: "text-neutral-500 border-neutral-800 bg-transparent", color: "#262626" },
};

export function OutcomeChip({ outcome, reason }) {
  const m = OUTCOME_META[outcome || "pending"] || OUTCOME_META.pending;
  return (
    <span title={reason || m.label} data-testid="conversation-outcome-chip" data-outcome={outcome || "pending"}
      className={`inline-flex items-center text-[0.6rem] font-semibold border rounded-full px-2 py-0.5 whitespace-nowrap ${m.cls}`}>
      {m.label}
    </span>
  );
}
